export default __webpack_public_path__ + "static/media/gnome1.43d44d7d.png";